import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    dirlist: [] // 代理人列表
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
